namespace('compass.hotel');

compass.hotel.RoomRequestsWidget = compass.defineWidget(function RoomRequestsWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _roomRequestArray = _settings.roomRequestOptions;
	var _accessibilityOptions = _settings.accessibilityOptions;
	var _WUID = _settings.WUID;

	var ACCESS_HEADER = "Pursuant to the Americans with Disabilities Act, I require specific aids or "
	 + "services during my visit.";

	var _setupControls = function() {

	};

	this.render = function(widgetElem) {
		var d = _d;
		widgetElem.append(me.drawRoomRequestForm());
		_setupControls();
	};

	this.drawRoomRequestForm = function() {
		var d = _d;
		return d.div({ className : 'roomRequestForm' },
			d.div({ className : 'requestInfo' }, 'Room requests cannot be guaranteed, but the property will do its best to meet your needs.'),
			me.drawRequestSelects(),
			me.drawExtraNotes(_settings.showExtraNotes),
			me.drawAccessibilityChecks()
		);
	};

	this.drawExtraNotes = function(showExtraNotes) {
		if(showExtraNotes) {
			var label = 'Please provide any additional notes about this reservation';
			var noteTextArea = _d.textarea({ className : 'notes', id: compass.generateId() }).change(function() {
				me.trigger('RoomRequestsWidget.roomNoteChanged');
			});
			/* Set value via jQuery because manual value setting is browser-specific on TextArea elements */
			$j(noteTextArea).val(_settings.notes);
			return [
				_d.fieldLabelPair({ className : 'extraNotes', label : label }, noteTextArea),
				_d.div({className : 'clear'})
			];
		}
	};

	var _checkboxes = {};
	this.drawAccessibilityChecks = function () {
		if(_accessibilityOptions && _settings.showADAOptions) {
			var d = _d;
			var options = _accessibilityOptions;
			var accessCheckArray = [];
			var accessHeaderId = compass.generateId();
			var accessChecks = d.fieldset({className: 'accessibilityChecks', 'aria-labelledby': accessHeaderId});

			var makeCheckSet = function (label, id, value, selected) {
				var requestOptionId = id;
				var id = compass.generateId();
				var box = d.input({ type: "checkbox", 'tabindex': '0', id: id, 'data-group': 'ada', checked : selected ? true : false, name: requestOptionId, value: value });
				var handler = function () {
					$j(this).trigger('roomRequestInputChanged', {
						'inputObj' : box,
						'roomRequestWidgetObj' : me
					});
				};
				box.activate(handler);
				_checkboxes[id] = box;

				return d.label({ className: 'adaCheckbox', 'for': id }, box, label);
			};
			accessChecks.append(
					d.div({ className: "accessHeader", id: accessHeaderId }, d.span(ACCESS_HEADER), d.reader('check all that apply') )
			);
			_.each(options, function(opt) {
				accessChecks.append(makeCheckSet(opt.name, opt.id, opt.value, opt.selected));
			});
			accessCheckArray.push(accessChecks, d.div({ className: "checkClear" }));

			return accessCheckArray;
		}
	};

	this.drawRequestSelects = function() {
		var d = _d;
		var requestOptionsArray = _roomRequestArray;

		if(requestOptionsArray) {
			var requestDivArray = _.map(requestOptionsArray, function(reqOptions) {
				var optionsArray = _.map(reqOptions.options, function(opt) {
					return d.option({
						selected : opt.selected ? true : false,
						value : opt.requestOptionId
					}, opt.name);
				});

				return d.fieldLabelPair({
					className : 'roomRequest',
					label : reqOptions.name},
					d.select({
						className : 'roomRequestSelect roomRequest',
						name : reqOptions.requestId,
						id: compass.generateId(),
						'tabindex': '0',
						onchange: function () {
							$j(this).trigger('roomRequestInputChanged', {'inputObj' : this, 'roomRequestWidgetObj' : me});
						}
					}, optionsArray));
			});
			requestDivArray.push(d.div({ className : 'clear' }));
			return requestDivArray;
		}
	};

	var _grabValues = function() {
		var values = me.find('.roomRequestForm :input,:selected').serializeArray();
		var jsonValues = {};
		jQuery.each(values, function(i, field) {
			jsonValues[field.name] = field.value;
		});
		jQuery('.roomRequestForm input[type=checkbox]:not(:checked)').each(function(i, field) {
			jsonValues[field.name] = "0";
		});

		var notes = me.find('.notes').val();

		return {
			requests : jsonValues,
			notes : notes
		};
	};
	this.grabValues = _grabValues;

	this.toggleContentDivDisplay = function() {
		var d = _d;
		$j('.roomRequestForm').toggle(500);
		return false;
	};

	this.validate = function() {
		return true;
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultRoomRequestsWidgetWUID',
	widgetName : 'RoomRequestsWidget',
	imgPath : '/resources/img',
	subclass : false,
	collapsable : false,
	roomRequestOptions : [],
	showExtraNotes : false,
	notes : ''
});

